import { AR_LINK } from "src/config";
import { useRootOutcomes } from "src/storage";
import { ModalFailure } from "src/ui/widgets";

export const OutcomeRoot = () => {
  const { topRootOutcome, removeTopRootOutcome } = useRootOutcomes();

  const homeDescription = "commons.go_to_ar";
  const onCloseHome = () => {
    window.location.replace(AR_LINK);
  };

  const errosMessages = topRootOutcome?.awsGateError?.response?.data.errors;
  let messageToVisualize = "";

  if (errosMessages != null && errosMessages.length > 0) {
    messageToVisualize = errosMessages.join("\n");
  } else {
    messageToVisualize = topRootOutcome?.awsGateError?.response?.data.message ?? '';
  }

  return (
    <ModalFailure
      visible={!!topRootOutcome && !topRootOutcome?.success}
      description={messageToVisualize}
      onClose={removeTopRootOutcome}
      buttonHome
      buttonReload
      buttonHomeDescription={homeDescription}
      onCloseHome={onCloseHome}
    />
  );
};
